import { render } from "./menu.md?vue&type=template&id=201da9da"
import script from "./menu.md?vue&type=script&lang=js"
export * from "./menu.md?vue&type=script&lang=js"
script.render = render

export default script